<template>
  <div class="app-main">
    <div class="header">
      <layout-header></layout-header>
    </div>
    <div class="mian">
      <div class="sub-menu">
        <sub-menu :collapsed='collapsed'></sub-menu>
      </div>
      <div class="mian-content">
        <div class="breadcrumb">
          <div class="collapsed" @click="toggleCollapsed">
            <MenuUnfoldOutlined v-if="collapsed" />
            <MenuFoldOutlined v-else />
          </div>
          <a-breadcrumb>
            <a-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">
              <router-link v-if="item.path" :to="item.path">{{item.name}}</router-link>
              <span v-else>{{item.name}}</span>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </div>
        <a-card class="card-flex">
          <router-view :key="$route.fullPath" />
        </a-card>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import SubMenu from '@/components/AppLayout/SubMenu.vue'
import LayoutHeader from '@/components/AppLayout/LayoutHeader.vue'
import { useRoute } from 'vue-router';
const collapsed = ref<boolean>(false)
const toggleCollapsed = () => {
  collapsed.value = !collapsed.value;
};
const userRoute = useRoute() // 当前路由信息
// 根据路由 返回面包屑
const breadcrumbList = computed<any[]>(() => {
  return userRoute.meta.breadcrumb as any[] ?? []
})
//#f2f2f2
</script>
<style lang="stylus" scoped>
.app-main
  width: 100%
  height: 100%
  display: flex
  flex-direction: column
.header
  flex-shrink: 0
.mian
  flex: 1
  display: flex
  overflow: hidden
.sub-menu
  flex-shrink: 0
  height: 100%
  overflow: auto
.mian-content
  flex: 1
  flex-direction: column
  padding: 20px
  overflow-y: auto
  background: #e9ecf3 
  display: flex
  .card-flex
    flex: 1
.breadcrumb
  display: flex
  align-items: center
  padding-bottom: 10px
.collapsed 
  font-size: 20px
  margin-right: 10px
  cursor: pointer
</style>

